<template>
  <header class="header-area navbar-light fixed-top" :class="{ 'is-sticky': scrolled }">
    <div class="container-fluid container-fluid--cp-150">
      <nav class="navbar navbar-expand-xl landing-navbar" id="navbar-example2">
        <router-link class="header-logo" to="/" data-analytics-id="header_logo">
          <img src="../assets/img/logo/logo-dark.png" width="180" height="34" alt="MoDeck" />
        </router-link>

        <div ref="mobileMenu" class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
          <ul class="nav main-menu" style="flex-shrink: 0" @click="handleMenuClick">
            <li class="nav-item">
              <a class="nav-link" href="#use-cases">
                <span>USE CASES</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#steps">
                <span>HOW IT WORKS</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#fit">
                <span>BEST FIT</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faq">
                <span>FAQ</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#pricing">
                <span>PRICING</span>
              </a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/docs">
                <span>DOCS</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/downloads">
                <span>DOWNLOAD</span>
              </router-link>
            </li>
            <!--<li class="nav-item">
              <router-link class="nav-link" to="/templatization">
                <span>TEMPLATIZATION SERVICE</span>
              </router-link>
            </li>-->
          </ul>
        </div>
        <div class="header-config-wrapper header-actions btn-group">
          <a class="login-link" href="https://app.modeck.io/login" data-analytics-id="header_login"><span>Log in</span></a>
          <a href="https://app.modeck.io/login?signup=1" class="ht-btn ht-btn--outline hire-btn d-xl-block signup-link" data-analytics-id="header_start_free"
            >Start for free</a
          >
          <button
            ref="menuToggle"
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    (function () {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach((each) => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, custom) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      if (e) {
        e.preventDefault();
      }
      var targetID = custom ? custom : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function () {
        const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 800);
    }

    if (this.$route.hash) {
      scrollAnchors(null, this.$route.hash);
    }

    document.addEventListener("click", this.handleDocumentClick);
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    async collapseMenu() {
      const menu = this.$refs.mobileMenu;
      if (!menu?.classList.contains("show")) return;

      const { Collapse } = await import('bootstrap');
      Collapse.getOrCreateInstance(menu, { toggle: false }).hide();
    },

    handleMenuClick(event) {
      if (event.target.closest?.("a")) {
        this.collapseMenu();
      }
    },

    handleDocumentClick(event) {
      const menu = this.$refs.mobileMenu;
      const toggle = this.$refs.menuToggle;
      if (!menu?.classList.contains("show")) return;

      if (!menu.contains(event.target) && !toggle?.contains(event.target)) {
        this.collapseMenu();
      }
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleDocumentClick);
  },
};
</script>

<style scoped>
.header-area,
.landing-navbar {
  background: #fff;
}

.header-logo {
  flex: 0 1 180px;
  min-width: 0;
}

.header-logo img {
  display: block;
  width: 100%;
  max-width: 180px;
  height: auto;
}

.header-actions {
  flex: 0 0 auto;
  align-items: center;
  margin: 8px 0 8px auto;
  white-space: nowrap;
}

.login-link span {
  display: inline-block;
  padding: 16px 25px;
  font-weight: 400;
}

.header-actions .navbar-toggler {
  margin-left: 10px;
}

@media (max-width: 1199.98px) {
  .landing-navbar .navbar-collapse {
    order: 3;
    flex-basis: 100%;
  }

  .landing-navbar .main-menu {
    flex-direction: column;
  }
}

@media (min-width: 1200px) and (max-width: 1279.98px) {
  .landing-navbar .main-menu .nav-link {
    padding-right: 8px;
    padding-left: 8px;
  }
}

@media (max-width: 575.98px) {
  .header-logo {
    flex-basis: clamp(82px, 26vw, 112px);
  }

  .login-link {
    font-size: 13px;
  }

  .login-link span {
    padding: 12px 6px;
  }

  .signup-link {
    height: 42px;
    padding: 0 8px;
    font-size: 13px;
    line-height: 38px;
  }

  .header-actions .navbar-toggler {
    width: 38px;
    height: 38px;
    margin-left: 4px;
    padding: 3px;
  }
}
</style>
